if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");
        this.formInput = this.form?.querySelector("[name=id]");

        if (this.formInput) {
          this.formInput.disabled = false;
        }

        this.form?.addEventListener(
          "submit",
          this.onSubmitHandler.bind(this),
        );

        this.cart = document.querySelector("cart-drawer");

        // AOV kan de standaard cart drawer vervangen.
        // Daarom nooit automatisch terugvallen op de cartpagina.
        this.cartType = this.cart?.dataset.cartType || "drawer";

        this.submitButton = this.querySelector('[type="submit"]');
        this.body = document.querySelector("body");

        this.submitButton?.addEventListener("click", (event) => {
          event.preventDefault();
          this.form?.requestSubmit();
        });

        if (this.cart) {
          this.submitButton?.setAttribute("aria-haspopup", "dialog");
        }

        this.hideErrors = this.dataset.hideErrors === "true";

        this.handleErrorMessage = this.handleErrorMessage.bind(this);
        this.redirectAfterSubmit = this.redirectAfterSubmit.bind(this);
        this.disableLoadingInButton =
          this.disableLoadingInButton.bind(this);
      }

      closeComplementaryProduct() {
        const complementaryOverlayPage = document.querySelector(
          ".wt__quick-buy--page-overlay",
        );

        if (this.body?.classList.contains("quick-buy-page-overlay")) {
          this.body.classList.remove("quick-buy-page-overlay");
        }

        if (
          complementaryOverlayPage?.classList.contains(
            "wt__quick-buy--page-overlay--open",
          )
        ) {
          complementaryOverlayPage.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );
        }
      }

      onSubmitHandler(event) {
        event.preventDefault();

        if (
          this.submitButton?.getAttribute("aria-disabled") === "true"
        ) {
          return;
        }

        this.handleErrorMessage();
        this.cart?.setActiveElement?.(document.activeElement);

        const loader = this.querySelector(
          ".loading-overlay__spinner",
        );

        this.submitButton?.setAttribute("aria-disabled", true);
        this.submitButton?.classList.add("loading");
        loader?.classList.remove("hidden");

        const config = fetchConfig("javascript");

        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];

        const formData = new FormData(this.form);

        /*
         * The BAM quantity selector stores the customer's actual
         * purchase choice on the product form. A one-time purchase
         * must never send a Shopify selling plan; otherwise Shopify
         * applies the Subscribe & Save price in the cart.
         */
        const purchaseMode =
          this.form?.dataset.bamPurchaseMode;

        if (purchaseMode === "one-time") {
          formData.delete("selling_plan");
        } else if (purchaseMode === "subscription") {
          /*
           * Root's subscription selector is associated with the
           * product form through its `form` attribute and can live
           * outside <product-form>. Copy its currently selected plan
           * into the exact /cart/add request so Subscribe & Save can
           * never fall back to a one-time purchase.
           */
          const formId = this.form?.getAttribute("id");

          const sellingPlanSelect = Array.from(
            document.querySelectorAll(
              ".wt-subscription-widget__plan-content__select",
            ),
          ).find(
            (select) =>
              !formId ||
              select.getAttribute("form") === formId,
          );

          const sellingPlanId =
            sellingPlanSelect?.value?.trim();

          if (sellingPlanId) {
            formData.set("selling_plan", sellingPlanId);
          }
        }

        if (
          this.cart &&
          typeof this.cart.getSectionsToRender === "function"
        ) {
          formData.append(
            "sections",
            this.cart
              .getSectionsToRender()
              .map((section) => section.id),
          );
        } else {
          formData.append("sections", []);
        }

        formData.append(
          "sections_url",
          window.location.pathname,
        );

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors:
                  response.errors || response.description,
                message: response.message,
              });

              this.handleErrorMessage(
                response.description,
              );

              this.error = true;

              const soldOutMessage =
                this.submitButton?.querySelector(
                  ".sold-out-message",
                );

              this.dispatchEvent(
                new CustomEvent("cart-drawer:refresh", {
                  detail: { response },
                  bubbles: true,
                  composed: true,
                }),
              );

              if (!soldOutMessage) {
                return;
              }

              this.submitButton?.setAttribute(
                "aria-disabled",
                true,
              );

              this.submitButton
                ?.querySelector("span")
                ?.classList.add("hidden");

              soldOutMessage.classList.remove("hidden");
              return;
            }

            if (!this.error) {
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              });
            }

            this.error = false;

            const quickAddModal =
              this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    this.redirectAfterSubmit(response);
                  });
                },
                { once: true },
              );

              if (this.cartType === "drawer") {
                quickAddModal.hide(true);
              }
            } else {
              const isClosedCart =
                !document.body.classList.contains(
                  "page-overlay-cart-on",
                );

              this.redirectAfterSubmit(
                response,
                isClosedCart,
              );
            }
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            if (
              this.cart?.classList.contains("is-empty")
            ) {
              this.cart.classList.remove("is-empty");
            }

            this.submitButton?.removeAttribute(
              "aria-disabled",
            );

            if (this.error) {
              this.disableLoadingInButton();
              return;
            }

            const quickAddContainer =
              document.querySelector(
                ".wt__quick-buy__container",
              );

            const quickAddOverlay =
              document.querySelector(
                ".wt__quick-buy--page-overlay",
              );

            if (quickAddContainer && quickAddOverlay) {
              const quickAddProduct =
                quickAddContainer.querySelector(
                  ".wt-product",
                );

              const quickAddLoader =
                quickAddContainer.querySelector(
                  ".wt__quick-buy-loader",
                );

              if (
                !quickAddContainer.classList.contains(
                  "hidden",
                )
              ) {
                quickAddProduct?.remove();

                quickAddContainer.classList.remove(
                  "wt__quick-buy__container--open",
                );

                quickAddOverlay.classList.remove(
                  "wt__quick-buy--page-overlay--open",
                );

                document.body.classList.remove(
                  "quick-buy-page-overlay",
                );

                quickAddLoader?.classList.remove(
                  "hidden",
                );
              }
            }

            setTimeout(() => {
              this.disableLoadingInButton();
            }, 200);
          });
      }

      disableLoadingInButton() {
        this.submitButton?.classList.remove("loading");

        this.querySelector(
          ".loading-overlay__spinner",
        )?.classList.add("hidden");
      }

      redirectAfterSubmit(
        response,
        isClosedCart = true,
      ) {
        if (this.dataset.instantCheckout === "true") {
          window.location = "/checkout";
          return;
        }

        const body = document.body;

        const isCartPage =
          body.classList.contains("template-cart");

        if (
          this.cartType === "drawer" &&
          isCartPage
        ) {
          const overlay = document.querySelector(
            ".wt__quick-buy--page-overlay",
          );

          overlay?.classList.remove(
            "wt__quick-buy--page-overlay--open",
          );

          body.classList.remove(
            "quick-buy-page-overlay",
          );
        }

        if (
          this.cart &&
          typeof this.cart.renderContents === "function"
        ) {
          this.cart.renderContents(
            response,
            isClosedCart,
          );

          return;
        }

        // AOV beheert de zichtbare cart drawer.
        // Alleen vernieuwen; nooit naar /cart sturen.
        document.dispatchEvent(
          new CustomEvent("cart-drawer:refresh", {
            detail: { response },
          }),
        );
      }

      handleErrorMessage(
        errorMessage = false,
      ) {
        if (this.hideErrors) {
          return;
        }

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(
            ".product-form__error-message-wrapper",
          );

        if (!this.errorMessageWrapper) {
          return;
        }

        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message",
          );

        this.errorMessageWrapper.toggleAttribute(
          "hidden",
          !errorMessage,
        );

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent =
            errorMessage;
        }
      }
    },
  );
}
